import { Component, inject, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';

import { ExternalUrlService } from 'app/shared/services/external-url.service';
import { NativeAppService } from 'app/shared/services/native-app.service';

import { environment } from 'env/environment';

@Component({
  selector: 'kh-helpcenter',
  styleUrls: ['./help-center.component.less'],
  templateUrl: './help-center.component.html',
  standalone: false
})
export class HelpCenterComponent implements OnInit {
  private readonly nativeAppService = inject(NativeAppService);
  private readonly externalUrlService = inject(ExternalUrlService);

  public isNativeApp = false;
  public supportEmail = environment.supportEmail;

  public ngOnInit(): void {
    this.isNativeApp = this.nativeAppService.isNativeApp();
  }

  public goToParentsExternalUrl(): void {
    this.externalUrlService.getExternalUrlObs('parents')
      .pipe(first())
      .subscribe((urlResult) => window.open(urlResult.Value, '_blank'));
  }
}
